export const TRACKING_TYPES = {
  affiliateCookie: 'affiliateCookie',
  affiliateClick: 'affiliateClick',
  affiliateRedirection: 'affiliateRedirection',
}
